export default __webpack_public_path__ + "static/fingerpainting-efa7400b6407d23e1a826894e4a782e6.mp4";